/* tslint:disable:typedef-whitespace align no-trailing-whitespace */

import { Action, ActionType    } from '@/models/action';
import { ModalService          } from '@/services/modal.service';

/**
 *
 * @class ProjectCreateFromAction
 *
 * @brief copy an existing project to one that is your own and will have its own (new) version history
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class ProjectCreateFromAction extends Action {

  private modals: ModalService        = null;

  constructor(options: any = null) {

    super({
      key:   'project.create.from',
      type:  ActionType.Project_Create_From,
      label: 'Clone',
      icon:  '<i class="fas fa-clone"></i>',
      tip:   'Copy an existing project to one that you own'
    });


    this.modals   = this.injector().get(ModalService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    this.modals.open('clone-project-modal');

    return true;
  }
}
